<template>
    <v-app>
        <fade-loader v-bind="fadeLoader">
            <router-view></router-view>
        </fade-loader>
    </v-app>
</template>

<script>
  export default {
    created () {
      // try to login
      this.$resolve(['auth/tryToResumeSession'])
    },
  }
</script>
